import { useAdvisor } from "../context/AdvisorContext";
import { MeetingDisplay } from "../../../features/meeting";
import { Box, Stack } from "@mui/material";

export const MeetingsSidebar = () => {
    const { advisor } = useAdvisor();

    const validMeetings = advisor?.meetings?.filter((meeting: any) => meeting.status !== "cancelled" && meeting.scheduler?.type !== "onboarding");
    const upcomingMeetings = validMeetings?.filter((meeting: any) => new Date(meeting.event_start) > new Date());


    return (
        <div className="display-box">
            <h5>Upcoming Meetings</h5>
            <Stack direction="column" spacing={2} mt={2}>
                {upcomingMeetings?.sort((a: any, b: any) => new Date(a.event_start).getTime() - new Date(b.event_start).getTime())?.map((meeting) => (
                    <Box key={meeting.uuid}>
                        <MeetingDisplay meeting={meeting} advisor={advisor} size="small" />
                    </Box>
                ))}
            </Stack>
        </div>
    )
}